export default {
  "about": "Informazioni",
  "about_title": "Chi siamo",
  "access_secret": "Segreto di accesso",
  "access_token": "Token di accesso",
  "accessibility_animations": "Animazioni",
  "accessibility_contrast": "Contrasto",
  "accessibility_font_size": "Dimensione carattere",
  "accessibility_title": "Accessibilità",
  "actions": "Azioni",
  "active": "Attivo",
  "active_ads": "Annunci Attivi",
  "active_campaigns": "Campagne Attive",
  "ad_code_placeholder": "<script>...</script> o codice slot AdSense",
  "ad_format": "Formato Annuncio",
  "ad_formats": "Formati Annunci",
  "ad_management": "Gestione Annunci",
  "ad_position_settings": "Impostazioni Posizione Annunci",
  "ad_price_list": "Listino Prezzi Annunci",
  "ad_pricing_formats_campaigns": "Prezzi, formati, campagne e tracciamento",
  "add": "Aggiungi",
  "add_api_keys": "Aggiungi chiavi API nella scheda Configura",
  "address": "Indirizzo",
  "admin": "Admin",
  "adminPanel": "Pannello di Amministrazione",
  "admin_ab_testing_title": "Test A/B",
  "admin_accent": "Accento",
  "admin_accent_color": "Colore accentato",
  "admin_action": "Azione",
  "admin_activate": "Attiva",
  "admin_active_feeds": "Feed Attivi",
  "admin_active_label": "ATTIVO",
  "admin_active_now": "Attivi Ora",
  "admin_active_subscribers": "Abbonati attivi",
  "admin_ad_performance": "Prestazioni Pubblicitarie",
  "admin_add_feed": "Aggiungi Feed",
  "admin_add_tag": "Aggiungi Etichetta",
  "admin_admins": "Amministratori",
  "admin_advertisements": "Pubblicità",
  "admin_advertiser_email": "Email dell'inserzionista",
  "admin_advertiser_name": "Nome dell'inserzionista",
  "admin_affiliate_links": "Link di Affiliazione",
  "admin_ai_content_title": "Elaborazione Contenuti AI",
  "admin_ai_prompt_settings": "Impostazioni Prompt & Modello AI",
  "admin_analytics_title": "Analisi",
  "admin_api_latency": "Latenza API",
  "admin_api_server": "Server API",
  "admin_article_actions": "Azioni",
  "admin_article_category": "Categoria",
  "admin_article_published": "Pubblicato",
  "admin_article_selector": "Selettore Articolo (CSS, es. article.news)",
  "admin_article_views": "Visualizzazioni",
  "admin_articles_count": "Articoli",
  "admin_articles_title": "Articoli",
  "admin_author_change_failed": "Cambio autore fallito.",
  "admin_authors_title": "Autori",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Salvataggio automatico come bozza",
  "admin_avg_seo_score": "Punteggio SEO Medio",
  "admin_bio": "Biografia",
  "admin_blog_manage": "Gestisci i post del blog con editor di contenuti ricco",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Marchio & Tema",
  "admin_branding_desc": "Personalizza l'aspetto del sito (Solo Amministratore di Sistema)",
  "admin_branding_title": "Modulo di Rebranding",
  "admin_breaking_ticker": "Ticker Notizie Flash",
  "admin_browser": "Browser",
  "admin_browsers": "Browser",
  "admin_bug_reports": "Segnalazioni di Bug",
  "admin_bulk_delete_failed": "Eliminazione massiva fallita.",
  "admin_bulk_operations": "Operazioni di Massa",
  "admin_categories_grid": "Griglia delle Categorie",
  "admin_choose_gallery": "Scegli dalla Galleria",
  "admin_churn_prediction": "Previsione del Churn",
  "admin_classic_portal": "Portale Classico di Notizie",
  "admin_classifieds": "Annunci",
  "admin_clear_log": "Cancella Log",
  "admin_click_button": "Clicca il pulsante",
  "admin_collection_stats": "Statistiche Raccolta",
  "admin_color_scheme": "Schema dei colori",
  "admin_columnist": "Editorialista",
  "admin_comments": "Commenti",
  "admin_competitor_monitoring": "Monitoraggio della Concorrenza",
  "admin_confirm_action": "Sei sicuro?",
  "admin_content_calendar_title": "Calendario dei Contenuti",
  "admin_content_filter": "Termini Filtro Contenuto",
  "admin_content_stats": "Statistiche Contenuto",
  "admin_contributor": "Collaboratore",
  "admin_coordinates": "Coordinate",
  "admin_copy_ip": "Copia indirizzo IP",
  "admin_copy_text": "Copia",
  "admin_core_services": "Servizi Principali",
  "admin_countries": "Paesi",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Esegui scansione ora",
  "admin_create_author": "Crea Autore",
  "admin_create_manage_promo": "Crea e gestisci codici promozionali",
  "admin_create_voucher": "Crea Voucher",
  "admin_custom_meta": "Meta Personalizzati",
  "admin_dashboard_title": "Dashboard",
  "admin_database": "Database",
  "admin_db_backup": "Backup del Database",
  "admin_db_latency": "Latenza DB",
  "admin_db_name": "Nome del database",
  "admin_db_size": "Dimensione DB",
  "admin_default": "PREDEFINITO",
  "admin_default_language": "Lingua predefinita",
  "admin_device": "Dispositivo",
  "admin_devices": "Dispositivi",
  "admin_discount": "Sconto",
  "admin_disk_usage": "Utilizzo Disco",
  "admin_docs_api_ref": "Riferimento API",
  "admin_docs_download_pdf": "Scarica PDF",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "Guida introduttiva",
  "admin_docs_implemented": "Implementato",
  "admin_docs_no_pages": "Nessuna pagina di documentazione ancora",
  "admin_docs_order": "Ordine",
  "admin_docs_title": "Documentazione",
  "admin_doktor_earnings": "Guadagni Doktor",
  "admin_draft_articles": "Articoli in Bozza",
  "admin_dynamic_pricing": "Prezzi Dinamici",
  "admin_edit_in_cms": "Modifica nel CMS",
  "admin_editor_role": "Editore",
  "admin_export_csv": "Esporta CSV",
  "admin_favicon": "Favicon",
  "admin_feed_crawler": "Crawler dei Feed",
  "admin_feed_name": "Nome Feed",
  "admin_feed_url": "URL Feed",
  "admin_feeds_title": "Feed RSS",
  "admin_file": "File",
  "admin_fixed_amount": "Importo Fisso",
  "admin_frozen": "Congelato",
  "admin_full_name": "Nome completo",
  "admin_general": "Generale",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Grado",
  "admin_health_title": "Verifica Stato",
  "admin_high_leads": "Contatti di Alto Valore",
  "admin_import_title": "Piattaforma di Importazione di Croatia Times",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Integrazioni",
  "admin_job_postings": "Pubblicazioni di Lavoro",
  "admin_joined": "Iscritto",
  "admin_keywords": "Parole chiave",
  "admin_landing_title": "Pagine di atterraggio",
  "admin_last_submissions": "Ultime Inviate",
  "admin_live_analytics": "Analisi in Tempo Reale",
  "admin_live_analytics_title": "Analisi in tempo reale",
  "admin_llm_model": "Modello LLM",
  "admin_manage_feeds": "Gestisci Feed",
  "admin_mass_management": "Gestione massiva articoli",
  "admin_max_articles": "Articoli max.",
  "admin_media_storage": "Archiviazione Media",
  "admin_memory": "Memoria",
  "admin_menu_manager": "Gestore del Menu",
  "admin_meta_description": "Descrizione Meta",
  "admin_monetization_title": "Dashboard di Monetizzazione",
  "admin_mysql_db": "Database MySQL",
  "admin_mysql_host": "Host MySQL",
  "admin_nav_ab_testing": "Test A/B",
  "admin_nav_ads": "Gestione Annunci",
  "admin_nav_ads_report": "Rapporto Annunci",
  "admin_nav_adsense": "Impostazioni AdSense",
  "admin_nav_advanced_analytics": "Analisi Avanzate",
  "admin_nav_affiliates": "Link Affiliati",
  "admin_nav_ai_content": "Elaborazione Contenuti AI",
  "admin_nav_amp": "AMP & Google Discover",
  "admin_nav_analytics": "Analisi",
  "admin_nav_analytics_ai": "Analisi & AI",
  "admin_nav_articles": "Articoli",
  "admin_nav_audit_log": "Registro di Verifica",
  "admin_nav_authors": "Autori",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Rimarchiatura",
  "admin_nav_breaking_news": "Notizie in primo piano / Flash",
  "admin_nav_bulk_operations": "Operazioni in Massa",
  "admin_nav_categories": "Categorie",
  "admin_nav_chat_sessions": "Sessioni di Chat",
  "admin_nav_churn_prediction": "Previsione dell'Abbandono",
  "admin_nav_classifieds": "Annunci",
  "admin_nav_comments": "Commenti",
  "admin_nav_competitor_monitoring": "Monitoraggio della Concorrenza",
  "admin_nav_content": "Contenuti",
  "admin_nav_content_calendar": "Calendario dei Contenuti",
  "admin_nav_county_map": "Mappa del County",
  "admin_nav_crypto": "Widget Crypto",
  "admin_nav_dashboard": "Cruscotto",
  "admin_nav_db_backup": "Database",
  "admin_nav_docs": "Documentazione",
  "admin_nav_doktor_earnings": "Guadagni Doktor",
  "admin_nav_duplicate_detection": "Rilevamento Duplicati",
  "admin_nav_editorial": "Editoriale",
  "admin_nav_editorial_workflow": "Flusso di lavoro editoriale",
  "admin_nav_email_campaigns": "Campagne Email",
  "admin_nav_feeds": "Feed RSS",
  "admin_nav_finance": "Finanza",
  "admin_nav_health": "Salute del Sistema",
  "admin_nav_heatmaps": "Mappa di Calore Lettura",
  "admin_nav_import": "Importa",
  "admin_nav_invoices": "Fatture",
  "admin_nav_job_ads": "Annunci di Lavoro",
  "admin_nav_landing_pages": "Pagine di Atterraggio",
  "admin_nav_live_analytics": "Analisi in tempo reale",
  "admin_nav_management": "Gestione",
  "admin_nav_marketing": "Marketing",
  "admin_nav_media": "Media",
  "admin_nav_menu_manager": "Gestore del Menu",
  "admin_nav_micropayments": "Micro-pagamenti",
  "admin_nav_monetization": "Monetizzazione",
  "admin_nav_newsletter": "Newsletter",
  "admin_nav_newsletter_digest": "Digest Newsletter",
  "admin_nav_pages": "Pagine",
  "admin_nav_payments": "Pagamenti",
  "admin_nav_performance_forecast": "Previsione delle Prestazioni",
  "admin_nav_photo_verification": "Verifica Foto",
  "admin_nav_portal_toggle": "Gestione Portale",
  "admin_nav_portals": "Portali",
  "admin_nav_pricing": "Prezzi",
  "admin_nav_promo_codes": "Codici Promozionali",
  "admin_nav_push_notifications": "Notifiche Push",
  "admin_nav_quizzes": "Quiz",
  "admin_nav_recommendations": "Raccomandazioni di Contenuto",
  "admin_nav_reports": "Rapporti di Contenuto",
  "admin_nav_sanitization": "Sanitizzazione dei Contenuti",
  "admin_nav_scheduler": "Programmatore di Contenuti",
  "admin_nav_security": "Sicurezza",
  "admin_nav_seo_dashboard": "Cruscotto SEO",
  "admin_nav_seo_distribution": "SEO & Distribuzione",
  "admin_nav_series": "Serie di Articoli",
  "admin_nav_settings": "Impostazioni",
  "admin_nav_social": "Social Media",
  "admin_nav_social_scheduler": "Pianificatore Social",
  "admin_nav_sponsored": "Sponsorizzato",
  "admin_nav_sponsored_marketplace": "Mercato Sponsorizzato",
  "admin_nav_subscriptions": "Abbonamenti",
  "admin_nav_surveys": "Sondaggi",
  "admin_nav_syndication": "Syndication API",
  "admin_nav_system": "Sistema",
  "admin_nav_tips": "Mance / Donazioni",
  "admin_nav_translations": "Traduzioni",
  "admin_nav_ugc_review": "Contenuto dei Cittadini",
  "admin_nav_users": "Utenti",
  "admin_nav_users_subscriptions": "Utenti & Abbonamenti",
  "admin_nav_versioning": "Storico Versioni",
  "admin_nav_vibeposao": "Portale Times Posao",
  "admin_nav_vouchers": "Buoni / Sconti",
  "admin_nav_widgets": "Widget / Cataloghi",
  "admin_new_author_name": "Nuovo nome autore...",
  "admin_new_post": "Nuovo Post",
  "admin_no_data": "Nessun dato disponibile",
  "admin_no_icon": "Nessuna icona",
  "admin_no_logo": "Nessun logo",
  "admin_no_pending_reports": "Nessuna segnalazione in sospeso",
  "admin_no_published_articles": "Nessun articolo pubblicato trovato",
  "admin_password_field": "Password",
  "admin_performance_forecast": "Previsione delle Prestazioni",
  "admin_photo_verification": "Verifica della Foto",
  "admin_plan": "Piano",
  "admin_platform_audit": "Audit della Piattaforma",
  "admin_portal_toggle": "Gestione Portale",
  "admin_premium_users": "Utenti Premium",
  "admin_primary": "Primaria",
  "admin_published_articles": "Articoli Pubblicati",
  "admin_published_today": "Pubblicati Oggi",
  "admin_quick_actions": "Azioni Rapide",
  "admin_recent_articles": "Articoli Recenti",
  "admin_role_change_failed": "Aggiornamento del ruolo fallito.",
  "admin_search_placeholder": "Cerca admin...",
  "admin_secondary": "Secondaria",
  "admin_seo_desc": "Ottimizzazione dei contenuti, gestione GSC e sitemap",
  "admin_seo_title": "Dashboard SEO",
  "admin_service_requests": "Richieste di Servizio",
  "admin_set_category": "Imposta Categoria",
  "admin_set_featured": "Imposta in Evidenza",
  "admin_settings_saved": "Impostazioni salvate",
  "admin_settings_title": "Impostazioni",
  "admin_short_desc": "Breve descrizione",
  "admin_site_identity": "Identità del sito",
  "admin_site_logo": "Logo del sito",
  "admin_site_settings": "Impostazioni del Sito",
  "admin_sponsored_marketplace": "Mercato Sponsorizzato",
  "admin_sponsored_title": "Articoli sponsorizzati",
  "admin_surveys_title": "Sondaggi",
  "admin_system_status": "Stato del Sistema",
  "admin_table_header_actions": "Azioni",
  "admin_table_header_date": "Data",
  "admin_table_header_email": "Email",
  "admin_table_header_name": "Nome",
  "admin_table_header_status": "Stato",
  "admin_thumbnail_settings_saved": "Impostazioni anteprima salvate",
  "admin_top_articles_views": "Articoli Principali per Visualizzazioni",
  "admin_total_articles": "Articoli Totali",
  "admin_total_users": "Utenti Totali",
  "admin_total_views": "Visualizzazioni Totali",
  "admin_ugc_review": "Revisione UGC",
  "admin_username": "Nome utente",
  "admin_users_title": "Utenti",
  "admin_version_history": "Storico delle Versioni",
  "admin_view_health_report": "Visualizza il rapporto completo sulla salute",
  "admin_write_new_article": "Scrivi Nuovo Articolo",
  "adsense_client_id": "ID Cliente AdSense",
  "adsense_enable_disable": "Abilita/disabilita tutto il servizio annunci automatico",
  "adsense_global_toggle": "Interruttore Globale AdSense",
  "adsense_script_code": "Codice Script AdSense",
  "adsense_settings": "Impostazioni AdSense & Posizioni Annunci",
  "advertise_contact_sales": "Contatta Vendite",
  "advertise_get_started": "Inizia Ora",
  "advertise_reach_audience": "Raggiungi il nostro pubblico",
  "advertise_title": "Pubblicizza con Noi",
  "advertiser": "Inserzionista",
  "advertiser_analytics": "Analisi Inserzionista",
  "advertiser_email": "Email Inserzionista",
  "advertising": "Pubblicità",
  "advertising_cookies": "Cookie pubblicitari",
  "affiliate_title": "Programma di Affiliazione",
  "ago": "fa",
  "ai_image_prompt": "Prompt Immagine AI",
  "all": "Tutti",
  "all_categories": "Tutte le Categorie",
  "all_jobs": "Tutti i Lavori",
  "all_rights": "Tutti i diritti riservati",
  "all_status": "Tutti gli Stati",
  "all_types": "Tutti i Tipi",
  "alpha": "Alfa",
  "alreadyHaveAccount": "Hai già un account?",
  "already_have_account": "Hai già un account?",
  "analytics": "Analisi",
  "analytics_cookies": "Cookie analitici",
  "api_key": "Chiave API",
  "api_secret": "Segreto API",
  "applications": "Candidature",
  "apply": "Applica",
  "apply_now": "Candidati Ora",
  "approve": "Approva",
  "approved": "Approvato",
  "archive": "Archivia",
  "archived": "Archiviato",
  "article_content": "Contenuto dell'Articolo",
  "article_title": "Titolo dell'Articolo...",
  "article_views": "Visualizzazioni",
  "author": "Autore",
  "auto_posting": "Posta automatica e integrazioni social",
  "auto_share_articles": "Condividi automaticamente gli articoli pubblicati sulle piattaforme connesse",
  "avg_ctr": "CTR Medio",
  "back": "Indietro",
  "basic": "Base",
  "be_respectful": "Sii rispettoso e civile con gli altri utenti e i soggetti degli articoli",
  "beta": "Beta",
  "book_ad": "Prenota Annuncio",
  "booking_details": "Dettagli Prenotazione",
  "breaking": "ULTIME NOTIZIE",
  "bug_description": "Descrizione del bug",
  "business": "Economia",
  "business_account_id": "ID account aziendale",
  "buyer": "Acquirente",
  "campaign_details": "Dettagli Campagna",
  "campaigns": "Campagne",
  "cancel": "Annulla",
  "caption": "Didascalia",
  "categories": "Categorie",
  "category": "Categoria",
  "category_distribution": "Distribuzione delle Categorie",
  "category_push_subscribers": "Iscritti alle notifiche di categoria",
  "chatbot_placeholder": "Scrivi un messaggio...",
  "chatbot_send": "Invia",
  "chatbot_title": "Assistente Chat",
  "choose_plan": "Scegli il Tuo Piano",
  "city": "Città",
  "classifieds": "Annunci",
  "classifieds_title": "Annunci",
  "clear": "Cancella",
  "click_rate": "Tasso di clic",
  "click_url": "URL di clic (destinazione)",
  "clicks": "Clic",
  "client_id": "ID cliente",
  "client_secret": "Segreto cliente",
  "close": "Chiudi",
  "code": "Codice",
  "commenting_rules": "Regole dei commenti",
  "comments": "Commenti",
  "companies": "Aziende",
  "company": "Azienda",
  "compose_social_post": "Crea post social",
  "configure": "Configura",
  "configure_position": "Configura ogni posizione con un'immagine banner personalizzata o un codice annuncio",
  "confirm": "Conferma",
  "confirm_delete": "Sei sicuro di voler eliminare?",
  "confirm_password": "Conferma Password",
  "congratulations": "Congratulazioni",
  "contact": "Contatto",
  "contact_title": "Contatto",
  "contact_us": "Contattaci",
  "content": "Contenuto",
  "cookies": "Cookies",
  "cookies_title": "Politica sui cookie",
  "copy": "Copia",
  "copyright": "Copyright",
  "copyright_notice": "Copyright",
  "count": "Conteggio",
  "country": "Paese",
  "cpm": "CPM",
  "create": "Crea",
  "create_first_ad": "Crea il tuo primo annuncio",
  "crypto_change_24h": "Variazione 24h",
  "crypto_market_cap": "Capitalizzazione di mercato",
  "crypto_price": "Prezzo",
  "crypto_widget_title": "Crypto",
  "ctr": "CTR",
  "culture": "Cultura",
  "current_plan": "Piano Attuale",
  "custom_ad_code": "Codice annuncio personalizzato",
  "custom_banner_url": "URL banner personalizzato",
  "custom_range": "Intervallo Personalizzato",
  "daily_budget": "Budget Giornaliero",
  "daily_performance": "Performance Giornaliera",
  "dark_mode": "Modalità Scura",
  "data_viz_title": "Visualizzazione dei Dati",
  "date": "Data",
  "dating_add_video": "Aggiungi un breve video così i potenziali abbinamenti possono conoscerti meglio",
  "dating_block": "Blocca",
  "dating_boosts": "Incrementi",
  "dating_city": "Città",
  "dating_next": "Prossimo",
  "dating_personality_quiz": "Quiz sulla personalità",
  "dating_quiz_completed": "Quiz sulla personalità completato",
  "dating_users": "Utenti",
  "dating_verify_identity": "Verifica che sei una persona reale",
  "dating_voice_message": "Messaggio vocale",
  "days": "giorni",
  "delete": "Elimina",
  "delete_failed": "Eliminazione fallita.",
  "deleted_successfully": "Eliminato con successo",
  "deprecated": "Deprecato",
  "describe_thumbnail": "Descrivi l'immagine di anteprima da generare...",
  "description": "Descrizione",
  "deselect_all": "Deseleziona Tutto",
  "desktop": "Desktop",
  "details": "Dettagli",
  "dimensions": "Dimensioni",
  "disabled": "Disabilitato",
  "dismiss": "Abbandona",
  "documentation": "Documentazione",
  "doktor_add_document": "Aggiungi Documento",
  "doktor_biography": "Biografia",
  "doktor_birth_date": "Data di Nascita",
  "doktor_chat": "Chat",
  "doktor_control_date": "Data di Controllo",
  "doktor_date": "Data",
  "doktor_diagnosis": "Diagnosi",
  "doktor_enter_name_specialization": "Inserisci nome e almeno una specializzazione",
  "doktor_enter_patient_name": "Inserisci il nome del paziente",
  "doktor_license_number": "Numero di Licenza",
  "doktor_panel": "Pannello Medico",
  "doktor_patient_name": "Nome del Paziente",
  "doktor_text_min_chars": "Il testo deve avere almeno 50 caratteri",
  "doktor_waiting_room": "Sala d'Attesa",
  "dont_have_account": "Non hai un account?",
  "download": "Scarica",
  "draft": "Bozza",
  "duplicate": "Duplica",
  "duration_days": "Durata (giorni)",
  "economy": "Economia",
  "edit": "Modifica",
  "electronics": "Elettronica",
  "email": "Email",
  "email_address": "Indirizzo email",
  "email_campaigns": "Campagne email",
  "email_clicks": "Clic email",
  "email_content": "Contenuto email...",
  "email_opens": "Aperture email",
  "email_placeholder": "Il tuo indirizzo email",
  "email_subject": "Oggetto email",
  "employer": "Datore di Lavoro",
  "enabled": "Abilitato",
  "end_date": "Data di Fine",
  "enter_advertiser_email": "Inserisci la tua email dell'inserzionista...",
  "enter_email_to_view": "Inserisci la tua email dell'inserzionista sopra per visualizzare la performance della tua campagna",
  "entertainment": "Intrattenimento",
  "error": "Errore",
  "error_deleting": "Errore durante l'eliminazione",
  "error_generating_digest": "Errore nella generazione del sommario",
  "error_loading": "Errore durante il caricamento",
  "error_saving": "Errore durante il salvataggio",
  "error_saving_settings": "Errore nel salvataggio",
  "error_sending": "Errore nell'invio",
  "error_uploading": "Errore nel caricamento",
  "error_uploading_photo": "Caricamento foto fallito",
  "events_calendar": "Calendario eventi",
  "excerpt_summary": "Estratto / Sommario",
  "experimental": "Sperimentale",
  "export": "Esporta",
  "export_data": "Esporta Dati",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Accesso con Facebook non disponibile",
  "failed_post_comment": "Invio commento fallito.",
  "feature_flags": "Funzionalità in Sperimentazione",
  "feature_job": "Metti in Evidenza Lavoro",
  "featured": "In evidenza",
  "featured_article": "Articolo in Evidenza",
  "featured_duration": "Durata In Primo Piano",
  "featured_image": "Immagine in Evidenza",
  "featured_jobs": "Lavori In Primo Piano",
  "feedback": "Feedback",
  "filter": "Filtra",
  "filter_terms_saved": "Termini del filtro salvati!",
  "find_jobs": "Trova Lavori",
  "first": "Prima",
  "first_process_publish": "Elabora e pubblica prima l'articolo",
  "footer_ai": "Questo portale utilizza assistenza AI per migliorare l'esperienza utente",
  "footer_ai_notice": "Alcuni contenuti creati con l'assistenza AI - segnala problemi",
  "footer_cat_business": "Affari",
  "footer_cat_culture": "Cultura",
  "footer_cat_health": "Salute",
  "footer_cat_news": "Notizie",
  "footer_cat_politics": "Politica",
  "footer_cat_sports": "Sport",
  "footer_cat_technology": "Tecnologia",
  "footer_categories": "Categorie",
  "footer_copyright": "2026 Liber Nostra d.o.o. Tutti i diritti riservati.",
  "footer_description": "Croatia Times è la tua fonte fidata per le ultime notizie, analisi approfondite e storie coinvolgenti dalla Croazia e oltre.",
  "footer_developed_by": "Sviluppato e mantenuto con amore da",
  "footer_email_placeholder": "Il tuo indirizzo email",
  "footer_here": "qui",
  "footer_hosted_by": "Ospitato da",
  "footer_link_about": "Chi Siamo",
  "footer_link_advertise": "Pubblicità",
  "footer_link_contact": "Contatto",
  "footer_link_cookies": "Cookie",
  "footer_link_imprint": "Impressum",
  "footer_link_privacy": "Informativa sulla Privacy",
  "footer_link_submit_news": "Invia Notizie",
  "footer_newsletter_text": "Iscriviti alla nostra newsletter",
  "footer_quick_links": "Link Rapidi",
  "footer_stay_informed": "Rimani Informato",
  "footer_subscribe": "Iscriviti",
  "for_you_personalized": "Contenuto personalizzato in base ai tuoi interessi",
  "for_you_title": "Per Te",
  "forgot_password": "Password dimenticata?",
  "free": "Gratuito",
  "free_plan": "Gratuito",
  "from": "Da",
  "full_time": "Tempo Pieno",
  "general": "Generale",
  "goodbye": "Arrivederci",
  "hashtags": "Hashtag",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "Pianificazione automatica attiva",
  "header_forecast": "Previsioni",
  "header_humidity": "Umidità",
  "header_live": "LIVE",
  "header_portals_label": "Portali",
  "header_weather_humidity": "Umidità",
  "header_weather_wind": "Vento",
  "header_wind": "Vento",
  "health": "Salute",
  "hello": "Ciao",
  "help": "Aiuto",
  "home": "Home",
  "home_podcast_title": "Riassunto Settimanale della Tecnologia: IA nelle Startup Croate",
  "home_video_title": "Dentro Zagabria: Documentario sulla Street Art",
  "hours": "ore",
  "import": "Importa",
  "impressions": "Impressioni",
  "imprint": "Impressum",
  "imprint_title": "Impressum",
  "inactive": "Inattivo",
  "info": "Informazioni",
  "instagram": "Instagram",
  "invalid_code": "Codice non valido. Riprova.",
  "items_selected": "elementi selezionati",
  "job_categories": "Categorie di Lavori",
  "job_postings": "Annunci di Lavoro",
  "job_seeker": "Candidato",
  "just_now": "Proprio ora",
  "language": "Lingua",
  "last": "Ultima",
  "latest_news": "Ultime Notizie",
  "legal": "Legale",
  "lifestyle": "Stile di Vita",
  "lifetime": "Per Sempre",
  "light_mode": "Modalità Chiara",
  "linked_email_campaign": "Collegato a campagna email",
  "linkedin": "LinkedIn",
  "live_stream": "Diretta streaming",
  "load_more": "Carica di più",
  "loading": "Caricamento in corso...",
  "local": "Locale",
  "location": "Località",
  "login": "Accedi",
  "logout": "Esci",
  "loyalty_available_points": "Punti disponibili",
  "loyalty_available_rewards": "Ricompense disponibili",
  "loyalty_badges": "Distintivi",
  "loyalty_consecutive_days": "Giorni consecutivi",
  "loyalty_error": "Errore",
  "loyalty_leaderboard": "Classifica",
  "loyalty_leaderboard_empty": "La classifica è vuota",
  "loyalty_rewards": "Ricompense",
  "loyalty_used_rewards": "Ricompense utilizzate",
  "majstor_categories": "Categorie",
  "majstor_city": "Città",
  "majstor_company_name": "Nome azienda *",
  "majstor_flexible": "Flessibile",
  "majstor_max_budget": "Budget max (EUR)",
  "majstor_min_budget": "Budget min (EUR)",
  "majstor_my_requests": "Le mie richieste",
  "majstor_request_title": "Titolo della richiesta *",
  "majstor_service_categories": "Categorie di servizio",
  "majstor_urgent": "Urgente",
  "manage": "Gestisci",
  "manage_bookings": "Gestisci prenotazioni inserzionista",
  "mark_as_read": "Segna come letto",
  "marketing_dashboard": "Cruscotto di Marketing",
  "marketing_live_metrics": "Metriche di Prestazione in Tempo Reale per Croatia Times",
  "marketing_published_articles": "Articoli Pubblicati",
  "marketing_registered_users": "Utenti Registrati",
  "marketing_today_views": "Visualizzazioni di Oggi",
  "marketing_total_views": "Visualizzazioni Totali della Pagina",
  "minutes": "minuti",
  "missing_translations": "Traduzioni mancanti",
  "mobile": "Mobile",
  "more": "Di più",
  "most_popular": "Più Popolare",
  "most_read": "I Più Letti",
  "move": "Sposta",
  "must_be_logged_in_purchase": "Devi essere loggato per acquistare un articolo",
  "myProfile": "Il Mio Profilo",
  "my_applications": "Le Mie Candidature",
  "name": "Nome",
  "new": "Nuovo",
  "new_article": "Nuovo Articolo",
  "new_campaign": "Nuova campagna",
  "new_notification": "Nuova notifica",
  "new_push_notification": "Nuova notifica push",
  "new_verification_sent": "Un nuovo codice di verifica è stato inviato alla tua email.",
  "news": "Notizie",
  "newsletter": "Newsletter",
  "newsletter_desc": "Iscriviti per le ultime notizie",
  "newsletter_only_subscribers": "Solo gli iscritti",
  "newsletter_subscribers": "Iscritti alla newsletter",
  "next": "Avanti",
  "no": "No",
  "noAccount": "Non hai un account?",
  "no_articles": "Nessun articolo trovato",
  "no_bookings": "Nessuna prenotazione trovata",
  "no_campaigns": "Nessuna campagna",
  "no_data": "Nessun dato disponibile",
  "no_items": "Nessun elemento trovato",
  "no_linked_campaign": "Nessuna campagna collegata",
  "no_notifications": "Nessuna notifica",
  "no_results": "Nessun risultato trovato",
  "no_scheduled_posts": "Nessun post programmato ancora",
  "no_sent_notifications": "Nessuna notifica inviata",
  "none": "Nessuno",
  "note": "Nota",
  "notification_body": "Corpo della notifica",
  "notification_title": "Titolo della notifica",
  "notifications": "Notifiche",
  "of": "di",
  "off": "Spento",
  "offline": "Offline",
  "on": "Acceso",
  "one_time": "una tantum",
  "online": "Online",
  "open_rate": "Tasso di apertura",
  "optional": "Opzionale",
  "options": "Opzioni",
  "orContinueWith": "O continua con",
  "or_continue_with": "O continua con",
  "order": "Ordine",
  "other": "Altro",
  "page": "Pagina",
  "part_time": "Part Time",
  "password": "Password",
  "paste": "Incolla",
  "pause": "Pausa",
  "payment_error": "Errore di Pagamento",
  "payment_processing": "Elaborazione del pagamento...",
  "payment_success": "Pagamento Riuscito!",
  "payment_thank_you": "Grazie per il tuo acquisto!",
  "pending": "In attesa",
  "pending_approval": "In Attesa di Approvazione",
  "per_month": "/mese",
  "per_page": "per pagina",
  "percentage": "Percentuale",
  "performance": "Performance",
  "phone": "Telefono",
  "platforms": "Piattaforme",
  "politics": "Politica",
  "poll_results": "Risultati",
  "poll_total_votes": "Voti totali",
  "poll_vote": "Vota",
  "popular": "Popolare",
  "post_comment": "Invia commento",
  "post_error": "Errore nel post",
  "post_job": "Pubblica un Lavoro",
  "post_now": "Pubblica ora",
  "powered_by": "Offerto da",
  "premium": "Premium",
  "preview": "Anteprima",
  "previous": "Precedente",
  "price": "Prezzo",
  "privacy": "Privacy",
  "privacy_title": "Informativa sulla privacy",
  "proceed_to_payment": "Procedi al Pagamento",
  "profile": "Profilo",
  "profile_admin_access": "Accesso Rapido Amministratore",
  "profile_analytics": "Analisi",
  "profile_articles": "Articoli",
  "profile_dashboard": "Cruscotto",
  "profile_edit": "Modifica Profilo",
  "profile_verified": "Profilo verificato!",
  "promo_success": "Codice promozionale applicato con successo!",
  "promote_job": "Promuovi Lavoro",
  "publish": "Pubblica",
  "published": "Pubblicato",
  "published_date": "Pubblicato",
  "push_notifications": "Notifiche push",
  "read": "Letto",
  "read_more": "Leggi di Più",
  "real_estate": "Immobiliare",
  "recent": "Recente",
  "recipes_add_first": "Aggiungi la tua prima ricetta",
  "recipes_browse_all": "Sfoglia tutte le ricette",
  "recipes_category": "Categoria",
  "recipes_cook_time": "Tempo di Cottura",
  "recipes_easy": "Facile",
  "recipes_featured": "Ricette in Evidenza",
  "recipes_filters": "Filtri",
  "recipes_ingredient": "Ingrediente",
  "recipes_ingredients": "Ingredienti",
  "recipes_instructions": "Istruzioni",
  "recipes_latest": "Ultime Ricette",
  "recipes_most_popular": "Ricette più Popolari",
  "recipes_prep_time": "Tempo di Preparazione",
  "recipes_search": "Cerca ricette...",
  "recipes_servings": "Porzioni",
  "recipes_title": "Ricette",
  "recommended": "Consigliato",
  "refresh": "Aggiorna",
  "region": "Regione",
  "register": "Registrati",
  "reject": "Rifiuta",
  "rejected": "Rifiutato",
  "related_articles": "Articoli Correlati",
  "remote": "Da remoto",
  "remove": "Rimuovi",
  "report": "Rapporto",
  "reports": "Rapporti",
  "reposting_rules_title": "Regole di ripubblicazione",
  "required": "Richiesto",
  "reset": "Reimposta",
  "restore": "Ripristina",
  "results": "Risultati",
  "resume": "Riprendi",
  "revision_restored": "Revisione ripristinata!",
  "salary": "Stipendio",
  "salary_max": "Stipendio Massimo",
  "salary_min": "Stipendio Minimo",
  "save": "Salva",
  "saved_jobs": "Lavori Salvati",
  "saved_successfully": "Salvato con successo",
  "schedule": "Programma",
  "scheduled": "Programmato",
  "science": "Scienza",
  "search": "Cerca...",
  "search_articles": "Cerca articoli...",
  "search_placeholder": "Cerca...",
  "search_results_for": "Risultati di ricerca per",
  "seconds": "secondi",
  "see_all": "Vedi tutto",
  "select": "Seleziona",
  "select_all": "Seleziona Tutto",
  "select_format": "Seleziona Formato",
  "seller": "Venditore",
  "send_campaign": "Invia campagna",
  "sent": "Inviato",
  "sent_campaigns": "Campagne Inviate",
  "services": "Servizi",
  "settings": "Impostazioni",
  "share": "Condividi",
  "showing": "Visualizzando",
  "signIn": "Accedi",
  "signOut": "Esci",
  "site_name": "Croatia Times",
  "site_subtitle": "Croazia Oggi",
  "six_digit_code": "Codice a 6 cifre",
  "social_media": "Social media",
  "social_scheduler": "Pianificatore social",
  "sort": "Ordina",
  "sponsored_marketplace_title": "Mercato Sponsorizzato",
  "sports": "Sport",
  "stable": "Stabile",
  "start": "Avvia",
  "start_date": "Data di Inizio",
  "static_about_contact": "Per richieste editoriali, pubblicità o informazioni generali, visita la nostra",
  "static_about_contact_page": "pagina dei contatti",
  "static_about_contact_title": "Contatto",
  "static_about_lead": "Croatia Times è un portale di notizie indipendente che ti offre le ultime notizie, analisi, commenti e storie dalla Croazia e dalla regione. Facciamo parte della famiglia mediatica e-mina.eu, con lo stesso team e gli stessi valori.",
  "static_about_mission": "Siamo dedicati a fornire un giornalismo accurato, tempestivo e di qualità che serva l'interesse pubblico. Il nostro team editoriale è composto da giornalisti esperti con una profonda conoscenza degli affari croati e regionali.",
  "static_about_mission_title": "La Nostra Missione",
  "static_about_publisher": "Liber Nostra d.o.o. è l'editore di Croatia Times ed e-mina.eu. L'azienda è specializzata in media digitali e portali di notizie focalizzati sul mercato croato.",
  "static_about_publisher_title": "Editore",
  "static_about_standards": "Croatia Times aderisce ai più alti standard giornalistici. Verifichiamo i fatti dei nostri report, etichettiamo chiaramente commenti e analisi, e correggiamo errori in modo rapido e trasparente.",
  "static_about_standards_title": "Standard Editoriali",
  "static_about_team": "Dietro a Croatia Times c'è un team di professionisti dei media esperti, giornalisti, redattori ed esperti tecnici che lavorano allo sviluppo della piattaforma e alla qualità dei contenuti. Il nostro team è lo stesso dietro il successo del portale e-mina.eu - Agenzia Internazionale di Notizie.",
  "static_about_team_title": "Squadra",
  "static_about_title": "Chi Siamo - Croatia Times",
  "static_bug_description": "Descrizione del bug",
  "static_bug_description_placeholder": "Descrivi cosa è successo e come riprodurre il problema...",
  "static_bug_intro": "Hai trovato qualcosa che non funziona correttamente? Faccelo sapere e lo risolveremo prontamente.",
  "static_bug_page_url": "URL della pagina (dove si è verificato il bug)",
  "static_bug_screenshot": "Screenshot (opzionale)",
  "static_bug_submit": "Invia segnalazione bug",
  "static_bug_submitting": "Invio in corso...",
  "static_bug_thanks": "Grazie per la tua segnalazione! Indagheremo e risolveremo il problema.",
  "static_bug_title": "Segnala un bug",
  "static_commenting_intro": "Accogliamo discussioni costruttive. Per mantenere la nostra sezione commenti positiva e produttiva, segui queste regole:",
  "static_commenting_login": "Per commentare, devi essere registrato e loggato a Croatia Times.",
  "static_commenting_rule_1": "Sii rispettoso e civile verso altri utenti e i soggetti degli articoli",
  "static_commenting_rule_2": "Nessun discorso d'odio, razzismo, sessismo o discriminazione di alcun tipo",
  "static_commenting_rule_3": "Nessun spam, pubblicità o contenuto promozionale",
  "static_commenting_rule_4": "Nessuna disinformazione o diffusione di affermazioni non verificate",
  "static_commenting_rule_5": "Nessun attacco personale o molestia",
  "static_commenting_rule_6": "Rimani sull'argomento e contribuisci alla conversazione",
  "static_commenting_rule_7": "Nessuna informazione personale o riservata su terzi",
  "static_commenting_title": "Regole per i Commenti",
  "static_commenting_violation": "I commenti che violano queste regole possono essere rimossi senza preavviso. I recidivi possono essere banditi permanentemente.",
  "static_contact_email": "Email",
  "static_contact_message": "Messaggio",
  "static_contact_message_placeholder": "Il tuo messaggio...",
  "static_contact_name": "Nome",
  "static_contact_name_placeholder": "Il tuo nome",
  "static_contact_send": "Invia Messaggio",
  "static_contact_sending": "Invio...",
  "static_contact_sent_desc": "Ti risponderemo entro 24 ore.",
  "static_contact_sent_title": "Messaggio Inviato!",
  "static_contact_subject": "Oggetto",
  "static_contact_subject_placeholder": "Come possiamo aiutarti?",
  "static_contact_title": "Contattaci",
  "static_cookies_advertising_text": "Potremmo utilizzare i cookie di Google AdSense per fornire pubblicità pertinenti.",
  "static_cookies_advertising_title": "Cookie Pubblicitari",
  "static_cookies_analytics_text": "Google Analytics ci aiuta a comprendere come i visitatori utilizzano il nostro sito. I dati sono anonimizzati ove possibile.",
  "static_cookies_analytics_title": "Cookie di Analisi",
  "static_cookies_managing_text": "Puoi controllare i cookie tramite le impostazioni del tuo browser. La disabilitazione dei cookie necessari può influire sulla funzionalità del sito.",
  "static_cookies_managing_title": "Gestione dei Cookie",
  "static_cookies_necessary_text": "Sono necessari per il funzionamento del sito (sessioni di accesso, preferenze del tema). Non possono essere disabilitati.",
  "static_cookies_necessary_title": "Cookie Necessari",
  "static_cookies_title": "Politica sui Cookie",
  "static_cookies_types_title": "Tipi di Cookie che Utilizziamo",
  "static_cookies_what_text": "I cookie sono piccoli file di testo posizionati sul tuo dispositivo quando visiti un sito web. Aiutano il sito a ricordare le tue preferenze e a comprendere come lo utilizzi.",
  "static_cookies_what_title": "Cosa Sono i Cookie",
  "static_imprint_ads_email": "Email (pubblicità):",
  "static_imprint_ai_notice": "Alcuni contenuti sono generati utilizzando la tecnologia AI. Segnala errori o contenuti inappropriati a",
  "static_imprint_contact": "Contatto",
  "static_imprint_copyright": "Copyright",
  "static_imprint_copyright_text": "Tutti i contenuti pubblicati su Croatia Times sono protetti da copyright. Liber Nostra d.o.o. detiene tutti i diritti sui testi, immagini e contenuti multimediali pubblicati su questo sito. Informazioni dettagliate sulle regole di ripubblicazione dei contenuti sono disponibili sulla",
  "static_imprint_ct_desc": "Portale di notizie Croatia Times",
  "static_imprint_disclaimer": "Disclaimer",
  "static_imprint_disclaimer_text": "Nonostante un attento controllo dei contenuti, non ci assumiamo responsabilità per i link esterni. I rispettivi operatori sono unicamente responsabili per i loro contenuti.",
  "static_imprint_editorial_email": "Email (editoriale):",
  "static_imprint_emina_desc": "Agenzia Internazionale di Notizie",
  "static_imprint_general_email": "Email (richieste generali):",
  "static_imprint_last_updated": "Ultimo aggiornamento: febbraio 2026",
  "static_imprint_or_via": "o tramite il nostro",
  "static_imprint_publisher": "Editore",
  "static_imprint_registered": "Registrato nella Repubblica di Croazia",
  "static_imprint_reposting_page": "pagina delle Regole di Ripubblicazione",
  "static_imprint_responsible": "Responsabile per il Contenuto",
  "static_imprint_responsible_text": "Team editoriale di Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Colofone",
  "static_imprint_websites": "Siti Web",
  "static_privacy_controller": "Titolare del trattamento: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Utilizziamo i cookie per funzionalità e analisi. Consulta la nostra Politica sui Cookie per i dettagli.",
  "static_privacy_cookies_title": "Cookie",
  "static_privacy_data_text": "Raccogliamo dati che fornisci direttamente (nome, email al momento dell'iscrizione), dati di utilizzo (pagine visitate, articoli letti) e dati tecnici (indirizzo IP, tipo di browser).",
  "static_privacy_data_title": "Dati che Raccogliamo",
  "static_privacy_last_updated": "Ultimo aggiornamento: gennaio 2026",
  "static_privacy_lead": "Croatia Times rispetta la tua privacy e si impegna a proteggere i tuoi dati personali.",
  "static_privacy_retention_text": "Conserviamo i tuoi dati finché il tuo account è attivo, o come necessario per scopi legali.",
  "static_privacy_retention_title": "Conservazione dei Dati",
  "static_privacy_rights_text": "Hai il diritto di accedere, correggere o cancellare i tuoi dati personali. Contattaci a",
  "static_privacy_rights_title": "I Tuoi Diritti",
  "static_privacy_title": "Informativa sulla Privacy",
  "static_privacy_usage_text": "Usiamo i tuoi dati per fornire il nostro servizio di notizie, personalizzare la tua esperienza, inviare newsletter (con il tuo consenso) e migliorare la nostra piattaforma.",
  "static_privacy_usage_title": "Come Usiamo i Tuoi Dati",
  "static_reposting_copyright_text": "Tutti i contenuti pubblicati su Croatia Times sono protetti da copyright. Liber Nostra d.o.o. detiene tutti i diritti sul testo, immagini e multimedia pubblicati su questo sito.",
  "static_reposting_copyright_title": "Copyright",
  "static_reposting_permission_text": "Per ottenere il permesso di ristampare contenuti, contattaci a",
  "static_reposting_permission_title": "Richieste di Permesso",
  "static_reposting_permitted_text": "Puoi condividere link ai nostri articoli sui social media e altre piattaforme. Brevi citazioni (fino a 2 paragrafi) possono essere utilizzate con chiara attribuzione e un link all'articolo originale.",
  "static_reposting_permitted_title": "Uso Permesso",
  "static_reposting_prohibited_text": "La ristampa completa degli articoli senza permesso scritto è vietata. Le immagini non possono essere riprodotte senza permesso. È severamente vietato il scraping automatizzato dei contenuti.",
  "static_reposting_prohibited_title": "Uso Proibito",
  "static_reposting_title": "Regole per il Ripubblicazione",
  "static_submit_news_details": "Dettagli della Storia",
  "static_submit_news_details_placeholder": "Descrivi la notizia...",
  "static_submit_news_file_limit_error": "Il file supera il limite di",
  "static_submit_news_headline": "Titolo della Notizia",
  "static_submit_news_intro": "Hai delle notizie? Inviacele qui e il nostro team editoriale le esaminerà.",
  "static_submit_news_limit": "Accettiamo foto e video fino a",
  "static_submit_news_photos": "Foto / Video (fino a",
  "static_submit_news_send": "Invia notizie",
  "static_submit_news_sending": "Invio in corso...",
  "static_submit_news_source": "Fonte / Riferimento (opzionale)",
  "static_submit_news_source_placeholder": "URL o riferimento",
  "static_submit_news_thanks": "Grazie per la tua segnalazione! Il nostro team la esaminerà a breve.",
  "static_submit_news_title": "Invia le Tue Notizie",
  "static_submit_news_your_name": "Il Tuo Nome",
  "status": "Stato",
  "stop": "Ferma",
  "submit": "Invia",
  "submitNews": "Invia Notizie",
  "submit_bug_title": "Invia segnalazione bug",
  "submit_news": "Invia Notizie",
  "submit_news_title": "Invia notizie",
  "subscribe": "Iscriviti",
  "subscription": "Abbonamento",
  "subscription_title": "Piani di abbonamento",
  "success": "Successo",
  "support": "Supporto",
  "tablet": "Tablet",
  "tags": "Tag",
  "target_impressions": "Impressioni Target",
  "technology": "Tecnologia",
  "template": "Modello",
  "templates": "Modelli",
  "terms": "Termini",
  "thank_you": "Grazie",
  "this_month": "Questo Mese",
  "this_week": "Questa Settimana",
  "this_year": "Quest'Anno",
  "tip": "Suggerimento",
  "title": "Titolo",
  "to": "A",
  "today": "Oggi",
  "total": "Totale",
  "translate_all": "Traduci tutto",
  "translation_status": "Stato traduzione",
  "translations": "Traduzioni",
  "travel": "Viaggi",
  "trending": "Di Tendenza",
  "try_again": "Riprova",
  "twitter": "Twitter",
  "two_factor_auth": "Autenticazione a Due Fattori",
  "type": "Tipo",
  "ugc_submit": "Invia Contenuto",
  "ugc_title": "Portale di Giornalismo Cittadino",
  "unique_clicks": "Clic unici",
  "unique_opens": "Aperture uniche",
  "unknown": "Sconosciuto",
  "unpublish": "Annulla pubblicazione",
  "unread": "Non letto",
  "update": "Aggiorna",
  "updated_successfully": "Aggiornato con successo",
  "upgrade": "Aggiorna",
  "upload": "Carica",
  "users": "Utenti",
  "vehicles": "Veicoli",
  "verification_code_sent": "Codice di verifica inviato alla tua email!",
  "version": "Versione",
  "vibeposao": "Times Posao",
  "view": "Visualizza",
  "view_all": "Vedi tutto",
  "views": "Visualizzazioni",
  "warning": "Avviso",
  "welcome": "Benvenuto",
  "wish_roles": "Ruoli Desiderati",
  "working_hours_saved": "Ore di lavoro risparmiate!",
  "world": "Mondo",
  "write_new_article": "Scrivi Nuovo Articolo",
  "yes": "Sì",
  "yesterday": "Ieri",
  "your_bookings": "Le Tue Prenotazioni",
  "youtube": "YouTube"
}
